var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFbmessenger02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0090FE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m4.041 15.429 6.664-7.034 3.39 3.39 5.864-3.116-6.529 6.936-3.427-3.393z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFbmessenger02);
export default __webpack_public_path__ + "static/media/ic-fbmessenger-02.638dde2cf3727e1622d5b90da834803b.svg";
export { ForwardRef as ReactComponent };